import {
  RESET_WAREHOUSES,
  RESET_SPECIFIC_WAREHOUSE,
  SET_WAREHOUSES,
  SET_SPECIFIC_WAREHOUSE,
} from "../Types/WarehouseTypes";

const initialState = {
  allWarehouses: [],
  specificWarehouse: null,
};

const WarehouseReducer = (state = initialState, action) => {
  if (action.type === SET_WAREHOUSES) {
    return { ...state, allWarehouses: action.payLoad };
  } else if (action.type === RESET_WAREHOUSES) {
    return { ...state, allWarehouses: [] };
  } else if (action.type === SET_SPECIFIC_WAREHOUSE) {
    return { ...state, specificWarehouse: action.payLoad };
  } else if (action.type === RESET_SPECIFIC_WAREHOUSE) {
    return { ...state, specificWarehouse: null };
  } else {
    return state;
  }
};

export default WarehouseReducer;
